<template>
  <div>
    <h4 class="is-size-3 has-text-black-bis mb-3">
      Notes
      <span class="is-pulled-right" v-tooltip="'Add New'">
        <i v-if="showAdd && !notesText.length" class="icon-addnew" @click="open"></i>
      </span>
    </h4>
  </div>
  <div class="file-lists">
    <div v-if="isEnabled">
       <div class="is-italic is-size-3 has-text-grey-darker line-height mb-2 has-text-left">
        {{ userName }}
        <span class="is-pulled-right buttons">
          <button class="button" @click="cancel">
            <i class="icon-close"></i>
          </button>
          <button class="button" @click="save">
            <i class="icon-checkmark has-text-success"></i>
          </button>
        </span>
      </div>
      <textarea class="textarea" rows="2" v-model="notesVal"></textarea>
    </div>
    <div v-else-if="notesText.length" class="mf-file column">
      <div class="columns mb-0 is-align-items-center">
        <div class="column is-size-3 has-text-grey-darker">
          {{ userName }}
        </div>
        <div class="column is-narrow is-align-items-center is-flex is-size-3 has-text-grey-darker">
          <span class="mr-2">{{ notesModified || createdAt}}</span>
          <span class="is-pulled-right edit-button">
            <button class="button is-hidden" v-if="isSchedule ? scheduleEdit : true">
            <i class="icon-edit" @click="edit"></i>
          </button>
          </span>
        </div>
      </div>
      <div class="column pt-0 pl-0">
        <div class="is-size-3 line-height has-text-left text-overflow clamp-10">        
          <p class="order-note line-height">{{ notesText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent, reactive, toRefs, computed, onMounted,
} from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import { trim, isObject, get } from 'lodash';

const MyComponent = defineComponent({
  name: 'mf-notes',
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    scheduleEdit: {
      type: Boolean,
      default: false,
    },
    isSchedule: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const data = reactive({
      isEnabled: false,
      userName: '',
      notesVal: '',
      notesModified: null,
      createdAt: null,
    });
    const cancel = () => {
      data.isEnabled = false;
      data.notesVal = '';
    };
    const notesText = computed({
      get: () => {
        const value = isObject(props.value) ? props.value.text : props.value;
        return (typeof value === 'string' || typeof value === 'number') ? trim(String(value)) : '';
      }, 
      set: (val) => {
        emit('update:value', val);
      },
    });

    const save = async () => {
      const newNote = trim(data.notesVal);
      const oldNote = notesText.value;
      if (newNote !== oldNote) {
        const user = await store.state.userData;
        data.userName = user.name;
        data.notesModified = moment().format('MM/DD/YYYY, h:mm:ss A');
        notesText.value = newNote;
      }
      data.notesVal = '';
      data.isEnabled = false;
    };

    const open = async () => {
      const user = await store.state.userData;
      data.userName = user.name;
      data.isEnabled = true;
      data.notesVal = '';
    };

     const edit = () => {
      data.isEnabled = true;
      data.notesVal = notesText.value;
    };

    onMounted(async () => {
      const user = await store.state.userData;
      data.userName = get(props.value, 'added.by.user.name', user.name);
      const addedAt = get(props.value, 'added.at', null);
      if (addedAt) {
        data.createdAt = data.notesModified = moment(addedAt).format('MM/DD/YYYY, h:mm:ss A');
      }
    });

    const showAdd = computed(() => {
      if (props.isSchedule && !props.scheduleEdit) return props.scheduleEdit;
      return !data.isEnabled;
    });

    return {
      ...toRefs(data),
      cancel,
      open,
      edit,
      save,
      notesText,
      showAdd,
    };
  },
});
export default MyComponent;
</script>
